module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAHvGGHrFGXrFGHnFGXfDGoaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABYALAAAAAAgACAAAAW+oCWOZGmeaGpWbKW+K+nCcAUA4j3TqH3/Ot7JBwTuhBZi0YhM2lgUJfNVqLYAUAhkGaS2bJFIa7tMvlgQyW+CaCmKouOq4nAUEW304BdPfbkHDSwSSmZDV1wADQwVhFNzYYk/BgYsP3IjY5JGllg9m6CYcTpSkl+fWIibCw8sPT5fpTcEAAktfpyqRV8FuLkTpby9qLmdN4SuFsPEl38AUck0wWGWt0jBDtWiNUud29KJ3zzBTcTR5XPn6OsoIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S2.gif
// module id = l09N
// module chunks = 48